module.exports = __webpack_public_path__ + "img/imagen7.d21d8ff8.png";